import React from 'react';
import { Link } from 'react-router-dom';
import './BlogIndexPage.css';

const posts = [
  {
    slug: 'what-is-csl-screening',
    title: 'What Is CSL Screening and Why Does It Matter?',
    date: 'March 6, 2026',
    readTime: '5 min read',
    description: 'Learn about the Consolidated Screening List, which government agencies maintain it, and why screening against it is a legal requirement for exporters.',
  },
  {
    slug: 'export-compliance-basics',
    title: 'Export Compliance Basics: A Guide for Small Businesses',
    date: 'March 6, 2026',
    readTime: '6 min read',
    description: 'A practical overview of export compliance obligations, from product classification to restricted party screening, tailored for small businesses.',
  },
  {
    slug: 'automated-vs-manual-screening',
    title: 'Automated vs. Manual Screening: Saving Time on Export Compliance',
    date: 'March 6, 2026',
    readTime: '5 min read',
    description: 'Compare the costs and benefits of manual restricted party screening with automated tools, and learn when it makes sense to switch.',
  },
];

const BlogIndexPage: React.FC = () => {
  return (
    <div className="blog-index">
      <h1>Blog</h1>
      <p className="blog-index-subtitle">Insights on export compliance, sanctions screening, and trade risk management.</p>
      <div className="blog-index-list">
        {posts.map((post) => (
          <Link key={post.slug} to={`/blog/${post.slug}`} className="blog-index-card">
            <h2>{post.title}</h2>
            <p className="blog-card-meta">{post.date} &middot; {post.readTime}</p>
            <p>{post.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BlogIndexPage;
